module.exports = __webpack_public_path__ + "static/media/2.GI fittings.057be513.jpg";